import { Directive, HostListener, inject, Input } from '@angular/core'
import { AnyObject } from '@naturalcycles/js-lib'
import { MixpanelService } from '@src/app/core/services/analytics/mixpanel.service.js'
import { MixpanelEvent } from '@src/app/shared/typings/analytics.js'

interface MixpanelEventDirectiveObject {
  eventName: string
  data?: AnyObject
}

@Directive({
  selector: '[mixpanelEvent]',
  standalone: false,
})
export class MixpanelEventDirective {
  private mixpanelService = inject(MixpanelService)
  @Input()
  mixpanelEvent!: string | MixpanelEventDirectiveObject

  @HostListener('click', ['$event'])
  onClick(): void {
    if (typeof this.mixpanelEvent === 'string') {
      void this.mixpanelService.trackEvent(MixpanelEvent.WebClick, {
        element: this.mixpanelEvent,
      })
      return
    }

    void this.mixpanelService.trackEvent(this.mixpanelEvent.eventName, this.mixpanelEvent.data)
  }
}
